module.exports = __webpack_public_path__ + "img/sarpaico.3ac8b05b.png";